import { render, staticRenderFns } from "./InterviewsDetail.vue?vue&type=template&id=708f92c2&scoped=true"
import script from "./InterviewsDetail.vue?vue&type=script&lang=js"
export * from "./InterviewsDetail.vue?vue&type=script&lang=js"
import style0 from "./InterviewsDetail.vue?vue&type=style&index=0&id=708f92c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f92c2",
  null
  
)

export default component.exports